module.exports = __webpack_public_path__ + "img/upload-alt.35a58390.svg";